import React from 'react';
import { Search, Eye, CheckCircle, Calendar } from 'lucide-react';
import CustomDropdown from '../CustomDropdown';

const FilterBar = ({
  isDarkMode,
  searchTerm,
  onSearchChange,
  itemsPerPage,
  onItemsPerPageChange,
  outcomeFilter,
  onOutcomeChange,
  dateFilter,
  onDateChange,
  itemsPerPageOptions,
  outcomeOptions
}) => {
  return (
    <>
      <div className="relative mb-6">
        <Search
          className={`absolute left-4 top-1/2 transform -translate-y-1/2 ${isDarkMode ? 'text-gray-400' : 'text-gray-400'} w-5 h-5`}
        />
        <input
          type="text"
          placeholder="Search by title or description..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className={`w-full pl-12 pr-6 py-3 text-base border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all shadow-sm ${isDarkMode
            ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400'
            : 'bg-white border-gray-200 text-gray-900 placeholder-gray-500'
            }`}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4">
        <div>
          <label className={`flex items-center text-sm font-semibold ${isDarkMode ? 'text-gray-300' : 'text-gray-700'} mb-3`}>
            <Eye className="w-4 h-4 mr-2" />
            Show per page
          </label>
          <CustomDropdown
            value={itemsPerPage}
            onChange={onItemsPerPageChange}
            options={itemsPerPageOptions}
            placeholder="Select items per page"
            isDarkMode={isDarkMode}
            icon={Eye}
          />
        </div>

        <div>
          <label className={`flex items-center text-sm font-semibold ${isDarkMode ? 'text-gray-300' : 'text-gray-700'} mb-3`}>
            <CheckCircle className="w-4 h-4 mr-2" />
            Outcome
          </label>
          <CustomDropdown
            value={outcomeFilter}
            onChange={onOutcomeChange}
            options={outcomeOptions}
            placeholder="Select outcome"
            isDarkMode={isDarkMode}
            icon={CheckCircle}
          />
        </div>

        <div>
          <label className={`flex items-center text-sm font-semibold ${isDarkMode ? 'text-gray-300' : 'text-gray-700'} mb-3`}>
            <Calendar className="w-4 h-4 mr-2" />
            Meeting Date
          </label>
          <div className={`flex items-center px-4 py-3 border rounded-xl shadow-sm ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'}`}>
            <Calendar className={`w-4 h-4 mr-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-500'}`} />
            <input
              type="date"
              value={dateFilter}
              onChange={(e) => onDateChange(e.target.value)}
              className={`w-full bg-transparent text-sm focus:outline-none ${isDarkMode ? 'text-white' : 'text-gray-900'}`}
            />
            {dateFilter && (
              <button
                type="button"
                onClick={() => onDateChange('')}
                className={`text-xs font-semibold ml-2 ${isDarkMode ? 'text-gray-300 hover:text-white' : 'text-gray-500 hover:text-gray-700'}`}
              >
                Clear
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterBar;
